var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('TransactionListTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"persistenceKey":'stock-adjustment-list',"setLoading":_vm.setLoading,"loadDataGrid":_vm.loaded}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }